import bowser from 'bowser'
import { setFatalError } from '../../FatalError/FatalError'

declare global {
  interface Window {
    webkitRTCPeerConnection: typeof RTCPeerConnection
  }
}

const ensureBrowserSupport = () => {
  /** Confirm browser is one of */
  if (
    !(
      bowser.chrome ||
      bowser.chromium ||
      bowser.firefox ||
      bowser.safari ||
      bowser.blink
    )
  ) {
    setFatalError('BROWSER_NOT_SUPPORTED')
    return false
  }

  /** WebRTC tech check */
  if (!window.webkitRTCPeerConnection && !window.RTCPeerConnection) {
    setFatalError('BROWSER_WEBRTC_NOT_SUPPORTED')
    return false
  }

  return true
}

export { ensureBrowserSupport }
